import React from 'react';
import styles from './AIGeneratedBadge.module.scss';
import MagicUploadSvg from '../../assets/Svg/MagicUploadSvg.svg';

interface AIGeneratedBadgeProps {
    className?: string;
}

const AIGeneratedBadge: React.FC<AIGeneratedBadgeProps> = ({ className }) => {
    return (
        <span className={`${styles.aiGenerated} ${className || ''}`}>
            <img src={MagicUploadSvg} alt="AI generated" />
            <span className={styles.aiGeneratedText}>AI generated</span>
        </span>
    );
};

export default AIGeneratedBadge;
